<div class="moving" [ngClass]="{'sub-layer-active': store.state.common.determinantSection.topLayer === 'edit'}">
  <layer-header
    (closeLayer)="closeLayer()"
    [listIcons]="false"
    [title]="notification.id ? 'Edit Guide Message' : 'Add Guide Message'"
  >
  </layer-header>
  <determinant-new
    *ngIf="store.state.common.determinantSection.topLayer === 'edit'"
    class="row layer sub-layer px-3 pt-1"
    [serviceId]="serviceId"
    [determinant]="store.state.common.determinantSection.determinant"
    (formSubmit)="closeEditDet()"
    (editCancel)="closeEditDet()"
  ></determinant-new>

  <div
    class="row {{
      store.state.common.determinantSection.topLayer === 'edit' ? 'hidden' : ''
    }}"
  >
    <div class="col-12">
      <div *ngIf="notification" class="form-group">
        <div class="row">
          <div class="col-12">
            <primary-text-button
              *ngIf="!notification.id"
              [noLeftPadding]="true"
              [disabled]="isLoading"
              (onClick)="addNewNotification()"
            >
              {{ 'general.create' | translate }}
            </primary-text-button>
            <primary-text-button
              *ngIf="notification.id"
              [noLeftPadding]="true"
              [disabled]="isLoading"
              (onClick)="saveNotification()"
            >
              {{ 'Save' | translate }}
            </primary-text-button>
            <confirmation
              [buttonName]="'general.delete'"
              [question]="'confirm.areyousure'"
              (isConfirmed)="deleteNotification($event)"
              *ngIf="notification.id != null"
            ></confirmation>
            <cancelary-text-button
              *ngIf="showCancelButton"
              (onClick)="closeLayer()"
            >
              {{ 'Cancel' | translate }}
            </cancelary-text-button>
          </div>
        </div>
      </div>

      <form *ngIf="notification" class="form-validation">
        <div class="panel panel-default">
          <div class="panel-body" style="padding-bottom: 0">
            <div class="form-group">
              <div class="row">
                <div class="col-2 col-label">
                  <label class="input-label">{{
                    'annexes.messages.value' | translate
                  }}</label>
                </div>
                <div class="col-9">
                  <input
                    class="form-control"
                    [(ngModel)]="notification.value"
                    type="text"
                    name="value"
                    [rangeLength]="[2, 256]"
                    autofocus
                  />
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col-2 col-label">
                  <label class="input-label">{{
                    'annexes.messages.body' | translate
                  }}</label>
                </div>
                <div class="col-9">
                  <textarea
                    *ngIf="notification"
                    class="form-control"
                    name="content"
                    style="height: 80px"
                    [(ngModel)]="notification.content"
                    #content="ngModel"
                    [rangeLength]="[2, 256]"
                    required
                  ></textarea>
                </div>
                <p
                  class="error"
                  *ngIf="content?.errors?.required && content?.touched"
                >
                  {{ 'form.validate.required' | translate }}
                </p>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col-2 col-label">
                  <label class="input-label">{{
                    'annexes.messages.tag' | translate
                  }}</label>
                </div>
                <div class="col-9">
                  <tag-input
                    [(ngModel)]="selectedTagItems"
                    [identifyBy]="'id'"
                    [displayBy]="'name'"
                    name="tag"
                    maxItems="1"
                    (ngModelChange)="dataChangedEvent($event)"
                    (onAdd)="onTagAdded($event)"
                    theme="bootstrap"
                  >
                    <tag-input-dropdown
                      [autocompleteItems]="tagItems"
                      [identifyBy]="'id'"
                      [displayBy]="'name'"
                    >
                    </tag-input-dropdown>
                  </tag-input>
                </div>
              </div>
            </div>

            <collapsible-pane
              [disableTitleMargins]="true"
              [hideContent]="true"
              style="width: 100%;display: block;margin-bottom: 1rem;"
              title="{{ 'Determinants' | translate }} ({{
                countNumberOfDeterminants()
              }})"
            >
              <div class="form-group" style="margin-bottom: 0">
                <determinant-builder-new
                  [showSaveCancelRow]="false"
                  [serviceId]="serviceId"
                  [jsonString]="notification.jsonDeterminants"
                  (onChange)="notification.jsonDeterminants = $event.jsonString"
                >
                </determinant-builder-new>
              </div>
            </collapsible-pane>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
